<template>
    <div class="p-animated-calc__share">
        <div class="m-mini-calc-icon--print">
            <svg viewBox="0 0 120 120" class="m-mini-calc-icon m-mini-calc-icon--dark" @click="print">
                <use xlink:href="#print"></use>
            </svg>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'mini-calculator-print',
        methods: {
            print() {
                const convertToArray = nodeList => Array.prototype.slice.call(nodeList);

                let page = window.open('', 'PRINT', 'height=800,width=600');
                let content = document.getElementById('print-panel');
                let newContent = content.cloneNode(true);
                let canvases = content.getElementsByTagName('canvas');
                let newCanvas = newContent.getElementsByTagName('canvas');

                // clone canvas content from originals.
                convertToArray(newCanvas)
                    .forEach((canvas, index) => canvas.getContext('2d').drawImage(canvases[index], 0, 0));

                // Remove this print icon
                newContent.querySelector('.p-animated-calc__share').remove();

                //Skeleton
                page.document.write('<html><head id="head"><title>' + document.title + '</title>');
                page.document.write('</head><body id="body" >');
                page.document.write('<h1>ABC Quantum Tool - Mini Calculation</h1>');
                page.document.write('</body></html>');

                // Append the new content
                page.document.getElementById('body')
                    .appendChild(newContent);

                let head = page.document.getElementById('head');
                // Insert into the head all CSS links and style tags (dev and live)
                convertToArray(document.getElementsByTagName('link')).forEach(link => head.appendChild(link.cloneNode(true)));
                convertToArray(document.getElementsByTagName('style')).forEach(style => head.appendChild(style.cloneNode(true)));
                // Reduce the size of the first vert box so it does not spread to two pages.
                let vert = page.document.querySelectorAll('#print-panel > .flex-grid--vertical')[1];
                if (vert) {
                    vert.style.height = 'inherit';
                }

                page.document.close(); // necessary for IE >= 10
                page.focus(); // necessary for IE >= 10*/

                page.print();
                page.close();

                return true;
            },
        }
    }

</script>


// WEBPACK FOOTER //
// MiniCalculatorPrint.vue?111876dc